import styled from 'styled-components';

export const HeaderTabsStyled = styled.div<any>`
  ${({ primaryColor }) =>
    primaryColor &&
    `
    .elmo-tabs__nav > ul > .elmo-tabs__item--active a:after {
      background-color: ${primaryColor} !important;
    }
  `}
`;
